import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import VNErklaerung, { getFormStrucVNErklaerung } from './content/ErklaerungMA_VN';

export const VNTreeStructureErklaerungen = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Erklärungen',
			content: <VNErklaerung />,
			formStruc: getFormStrucVNErklaerung(),
		},
	];

	return treeNodes;
};
